import {
  selectDocHubUserItemCount,
  selectEntities,
  selectIsSelectAll,
  selectItemCount,
  selectSapRadio,
  selectSelectedDocuments, selectSelectedDocumentsCount, selectUnselectedDocuments,
  selectUnselectedDocumentsCount,
  selectUploadedDocuments,
  selectUserItemCount,
} from 'Selector/DocumentHubSelector';
import { actions } from 'Slice/DocumentHubSlice';
import { FolderType } from 'Types/DocumentHubTypes';
import { useDispatch, useSelector } from 'react-redux';

export const useDocumentHubSelection = (type = '') => {
  const dispatch = useDispatch();
  const isSelectAll = useSelector(selectIsSelectAll);
  const selectedDocuments = useSelector(selectSelectedDocuments);
  const unSelectedDocuments = useSelector(selectUnselectedDocuments);
  const entities = useSelector(selectEntities);
  const uploadedDocuments = useSelector(selectUploadedDocuments);
  const documents = uploadedDocuments.length
    ? [...uploadedDocuments, ...entities] : entities;
  const selectedDocumentCount = useSelector(selectSelectedDocumentsCount);
  const unselectedDocumentCount = useSelector(selectUnselectedDocumentsCount);
  const userItemCount = useSelector(selectUserItemCount);
  const itemCount = useSelector(selectItemCount);
  const docHubUserItemCount = useSelector(selectDocHubUserItemCount);
  const radio = useSelector(selectSapRadio);

  const headerCheckboxChecked = () => {
    if (type === 'sap') {
      return documents.every((doc) => doc.isSelected) && !unSelectedDocuments.length;
    }
    const filteredDocuments = documents.filter((document) => document.deleteAllowed);
    if (userItemCount === 0) {
      return false;
    }
    if (filteredDocuments?.length) {
      return filteredDocuments.every((doc) => doc.isSelected) && !unSelectedDocuments.length;
    }
    return isSelectAll && !unselectedDocumentCount;
  };

  const isHeaderCheckboxChecked = headerCheckboxChecked();

  const handleCheckAll = (onlyGilroyToggle = false) => {
    if (onlyGilroyToggle) {
      dispatch(actions.setIsItemsSelectAllGilroy(true));
    }
    else {
      dispatch(actions.setIsItemsSelectAll(isHeaderCheckboxChecked));
    }
    dispatch(actions.setSelectedDocumentsCount(isHeaderCheckboxChecked && !onlyGilroyToggle ? 0 : type === 'sap' && radio === 'custom' ? itemCount : type === 'sap' && radio === 'document' ? docHubUserItemCount : userItemCount));
  };

  const updateSelectionWithoutSearch = (id: number, prevSelected: boolean, docType: FolderType, count: number) => {
    const prevCount = selectedDocumentCount || 0;
    if (!isSelectAll && !prevSelected) {
      dispatch(actions.setSelectedDocuments([...selectedDocuments, { id, type: docType, count }]));
      dispatch(actions.setSelectedDocumentsCount(prevCount + count));
      dispatch(actions.setUnselectedDocumentsCount(unselectedDocumentCount - count));
    } else if (!isSelectAll && prevSelected) {
      dispatch(actions.setSelectedDocuments(selectedDocuments.filter((doc) => doc.id !== id)));
      dispatch(actions.setSelectedDocumentsCount(prevCount - count));
      dispatch(actions.setUnselectedDocumentsCount(unselectedDocumentCount + count));
    } else if (isSelectAll && prevSelected) {
      dispatch(actions.setUnselectedDocuments([...unSelectedDocuments, { id, type: docType, count }]));
      dispatch(actions.setSelectedDocumentsCount(prevCount - count));
      dispatch(actions.setUnselectedDocumentsCount(unselectedDocumentCount + count));
    } else if (isSelectAll && !prevSelected) {
      dispatch(actions.setUnselectedDocuments(unSelectedDocuments.filter((doc) => doc.id !== id)));
      dispatch(actions.setSelectedDocumentsCount(prevCount + count));
      dispatch(actions.setUnselectedDocumentsCount(unselectedDocumentCount - count));
    }
  };

  const handleCheckBoxClick = (id: number, isSelected: boolean, docType: FolderType, count: number) => {
    dispatch(actions.setSelectDocument(id));
    updateSelectionWithoutSearch(id, isSelected, docType, count);
  };

  return {
    handleCheckAll, handleCheckBoxClick, isHeaderCheckboxChecked,
  };
};
